import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Space } from 'antd';
import useForm from '../../hooks/useForm';
import PageTitle from '../PageTitle';
import FormWrapper from '../FormWrapper';
import SaveButton from '../buttons/SaveButton';
import CancelButton from '../buttons/CancelButton';
import usePermissions from '../../hooks/usePermission';

const permissionsMap = {
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const EditCouncilDecisionForm = ({ councilDecision, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const { canEdit } = usePermissions(permissionsMap);
  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        name: yup.string().required(t('errors.notEmpty')),
        startDate: yup.date().nullable().required(t('errors.notEmpty')),
      }),
    [t],
  );

  const { value, handleSubmit, input, custom, setFormValue } = useForm({
    initialValue: councilDecision,
    schema: validationSchema,
    onSubmit,
    onCancel,
  });

  useEffect(() => {
    setFormValue(councilDecision);
  }, [setFormValue, councilDecision]);

  const { deleted } = value;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PageTitle
          title={
            councilDecision.name ||
            t('entity.taxonomy.councilDecision._singular')
          }
        />

        <FormWrapper>
          <FormWrapper.Single>
            <FormWrapper.Input
              label={t('entity.taxonomy.councilDecision.name')}
              props={{ ...input('name'), disabled: deleted || !canEdit }}
            />
            <FormWrapper.TextArea
              label={t('entity.taxonomy.councilDecision.description')}
              props={{
                ...input('description'),
                rows: 6,
                maxlength: 3000,
                disabled: deleted || !canEdit,
              }}
            />
            <FormWrapper.DateTimePicker
              key="startDate"
              label={t(`entity.taxonomy.councilDecision.startDate`)}
              props={{
                ...custom('startDate'),
                hideTime: true,
                disabled: deleted || !canEdit,
                toMidnightDown: true,
              }}
            />
            <Space style={{ paddingTop: '1rem' }}>
              {!deleted && canEdit && <SaveButton />}
              <CancelButton onCancel={onCancel} />
            </Space>
          </FormWrapper.Single>
        </FormWrapper>
      </form>
    </>
  );
};

export default EditCouncilDecisionForm;
